import {
    GET_SETTING_LISTING,
    GET_SETTING_LISTING_SUCCESS,
    GET_SETTING_LISTING_FAIL,
    UPDATE_SETTING,
    UPDATE_SETTING_SUCCESS,
    UPDATE_SETTING_FAIL,
    RESET_SETTING_STATE,
    UPDATE_POINT,
    UPDATE_POINT_FAIL,
    UPDATE_POINT_SUCCESS,
    GET_POINT_LISTING_FAIL,
    GET_POINT_LISTING_SUCCESS,
    GET_POINT_LISTING,
} from "./actionTypes";

export const getSettingListing = () => ({
    type: GET_SETTING_LISTING,
});

export const getSettingListingSuccess = service => ({
    type: GET_SETTING_LISTING_SUCCESS,
    payload: service,
});

export const getSettingListingFail = error => ({
    type: GET_SETTING_LISTING_FAIL,
    payload: error,
});

export const updateSetting = service => ({
    type: UPDATE_SETTING,
    payload: service,
});

export const updateSettingSuccess = service => ({
    type: UPDATE_SETTING_SUCCESS,
    payload: service,
});

export const updateSettingFail = error => ({
    type: UPDATE_SETTING_FAIL,
    payload: error,
});

export const getPointListing = () => ({
    type: GET_POINT_LISTING,
});

export const getPointListingSuccess = service => ({
    type: GET_POINT_LISTING_SUCCESS,
    payload: service,
});

export const getPointListingFail = error => ({
    type: GET_POINT_LISTING_FAIL,
    payload: error,
});

export const updatePoint = service => ({
    type: UPDATE_POINT,
    payload: service,
});

export const updatePointSuccess = service => ({
    type: UPDATE_POINT_SUCCESS,
    payload: service,
});

export const updatePointFail = error => ({
    type: UPDATE_POINT_FAIL,
    payload: error,
});

//reset
export const resetSettingState = () => {
    return {
        type: RESET_SETTING_STATE,
    }
}

